<!-- eslint-disable max-len -->
<template>
  <div
    class="w-screen h-screen flex flex-col md:flex-row align-middle md:justify-center"
  >
    <div class="h-full w-full bg-white md:bg-[#403e3e] -z-20">
      <img
        class="desktop_img h-full w-fit mx-auto"
        src="../../assets/img/bm1-bg-tr2.png"
        alt="profile picture"
      />
      <img
        class="mobile_img mb-14 xxs:mb-0 p-1 rounded-full shadow w-10/12 m-auto"
        src="../../assets/img/behailu-mob.png"
        alt="profile picture"
      />
      <vue-particles
        id="tsparticles"
        class="absolute -z-10 hidden md:block"
        @particles-loaded="particlesLoaded"
        :options="{
          background: {},
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: 'push',
              },
              onHover: {
                enable: true,
                mode: 'repulse',
              },
            },
            modes: {
              bubble: {
                distance: 500,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: 'rgb(249 198 17)',
            },
            links: {
              color: 'rgb(249 198 17)',
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            move: {
              direction: 'none',
              enable: true,
              outModes: 'bounce',
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
              },
              value: 100,
            },
            opacity: {
              value: 0.5,
            },

            shape: {
              type: 'circle',
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
        }"
      />
    </div>
    <div
      class="flex flex-col w-full h-full py-10 bg-white text-[#6b6d70] text-left px-10 align-middle justify-center"
    >
      <div class="">
        <p class="font-medium text-3xl tracking-tight fadeIn">
          HELLO! I'M
          <span class="text-pinksh uppercase">
            <strong>Behailu Mesganaw</strong>
          </span>
        </p>

        <p class="font-semibold pb-7 xl:pb-5 text-lg lg:text-xl fadeIn">
          a Full-Stack Developer based in Addis Ababa, Ethiopia, with a degree
          in Electrical and Computer Engineering.
        </p>
      </div>
      <div class="">
        <ul v-for="skill in technicalSkills" :key="skill.name">
          <li class="my-4">
            <div class="gap-2">
              <p class="text-pinksh font-semibold">{{ skill.name }}</p>
              <div class="flex flex-wrap gap-2 w-fit">
                <div v-for="value in skill.value" :key="value">
                  <p class="border-1 border-[#6b6d70] px-1 rounded-sm">
                    {{ value }}
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <router-link
        to="/about-me"
        class="fadeIn bg-pinksh w-fit text-sm font-bold text-white hover:opacity-70 px-7 py-3 mt-4 rounded-full"
      >
        More About Me
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "Auto-play",

  setup() {
    const showResume = ref<boolean>(false);

    interface ISkill {
      name: string;
      value: string[];
    }

    const particlesLoaded = async (container: any) => {
      console.log("Particles container loaded", container);
    };

    const technicalSkills: Array<ISkill> = [
      {
        name: "Programming Languages",
        value: ["JavaScript", "TypeScript", "Dart", "PHP"],
      },
      {
        name: "Frontend Framworks",
        value: ["Vue.js", "React.js", "Next.Js"],
      },
      {
        name: "Backend Framworks",
        value: ["Laravel", "Express.js"],
      },
      { name: "Mobile Development", value: ["Flutter"] },
      {
        name: "CMS & E-Commerce",
        value: ["WordPress", "Shopify"],
      },
    ];

    return {
      showResume,
      technicalSkills,
      particlesLoaded,
    };
  },
});
</script>

<style scoped lang="scss">
.fadeIn {
  visibility: visible;
  animation: fadeIn 0.8s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate3d(0, 30%, 0);
    --webkit-transform: translate3d(0, 30%, 0);
  }
  to {
    opacity: 1;
    transform: none;
    --webkit-transform: none;
  }
}
@media only screen and (max-width: 768px) {
  .desktop_img {
    display: none;
  }
  .mobile_img {
    display: block;
  }
  // .bg-img {
  //   .bm-pic {
  //     display: block;
  //     width: 215px;
  //     height: auto;
  //   }
  // }
}
@media only screen and (min-width: 768px) {
  .desktop_img {
    display: block;
  }
  .mobile_img {
    display: none;
  }
  // .bg-img {
  //   .bm-pic {
  //     display: block;
  //     width: 215px;
  //     height: auto;
  //   }
  // }
  // .container {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   flex-direction: column;
  // }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .bg-img {
    background-image: url("../../assets/img/bm1-bg-tr2.png");
    background-position-x: 45%;
    background-position-y: -45px;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #6b6d70;
    object-fit: cover;
    object-position: center;
    border-bottom-left-radius: 50% 20%;
    border-bottom-right-radius: 50% 20%;
    box-shadow: white 1px 1px;
    .bm-pic {
      display: none;
    }
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .bg-img {
    background-position-x: 40%;
  }
}

@keyframes brightShadow {
  from {
    box-shadow: 1px 1px 20px 1px rgba(5, 237, 5, 0.2);
  }
  to {
    box-shadow: 1px 1px 20px 1px rgba(5, 237, 5, 0.3);
  }
}
</style>
